import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/app/node_modules/.pnpm/@datadog+browser-rum-nextjs@7.2.0_@datadog+browser-rum@7.2.0_next@16.2.6_@babel+core@7._54bb260dfad4bc34b3e5c4211000ed3e/node_modules/@datadog/browser-rum-nextjs/esm/domain/error/errorBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["DatadogAppRouter"] */ "/app/node_modules/.pnpm/@datadog+browser-rum-nextjs@7.2.0_@datadog+browser-rum@7.2.0_next@16.2.6_@babel+core@7._54bb260dfad4bc34b3e5c4211000ed3e/node_modules/@datadog/browser-rum-nextjs/esm/domain/nextJSRouter/datadogAppRouter.js");
;
import(/* webpackMode: "eager", webpackExports: ["DataProvider","PlasmicCanvasHost","PlasmicComponent","PlasmicRootProvider","usePlasmicCanvasContext","usePlasmicQueryData","useSelector"] */ "/app/node_modules/.pnpm/@plasmicapp+loader-nextjs@2.0.6_next@16.2.6_@babel+core@7.29.7_@opentelemetry+api@1.9.1_3afb89bbb53693006f57ab37d0229103/node_modules/@plasmicapp/loader-nextjs/dist/index.esm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.2.6_@babel+core@7.29.7_@opentelemetry+api@1.9.1_babel-plugin-macros@3.1.0_react_746a9702317239837d695e91199000cd/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.2.6_@babel+core@7.29.7_@opentelemetry+api@1.9.1_babel-plugin-macros@3.1.0_react_746a9702317239837d695e91199000cd/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/packages/services/dist/js/error-reporting/app-router-tracker.js");
;
import(/* webpackMode: "eager", webpackExports: ["NextOsanoScripts"] */ "/app/packages/services/dist/js/osano.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/stadium-shops/src/app/[meta]/(withProviderRoutes)/auth-wrapper.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/stadium-shops/src/app/[meta]/(withProviderRoutes)/react-query-client.js");
;
import(/* webpackMode: "eager" */ "/app/packages/stadium-shops/src/client/wrappers.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/stadium-shops/src/components/app-analytics-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/stadium-shops/src/components/error-boundary/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/stadium-shops/src/components/global-scripts.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/stadium-shops/src/components/provider/analytics.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/assets/images/svg/brands/snackmagic.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/assets/images/svg/brands/stadium-logo.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/assets/images/svg/brands/stadium-mobile.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/assets/images/svg/brands/stadium.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/assets/images/svg/brands/swagmagic.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/assets/images/svg/snackmagic.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/assets/images/svg/swagmagic.svg");
